import { StampInfo } from './StampInfo';
import { ComboBoxAeroporto } from '../../../../app/app-datahealth/app-search-information-by-date-and-rpe/model/combo-box-aeroporto';

export class StampTransfer {

    stampInfo: Array<StampInfo>;
    aeroportos: Array<ComboBoxAeroporto>;

}
